module.exports = {"140781001":"北关街道","140781002":"西关街道","140781003":"东南街道","140781004":"西南街道","140781005":"北坛街道","140781100":"义安镇","140781101":"张兰镇","140781102":"连福镇","140781103":"洪山镇","140781104":"龙凤镇","140781105":"绵山镇","140781106":"义棠镇","140781200":"城关乡","140781201":"宋古乡","140781202":"三佳乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140781.json
// module id = 332
// module chunks = 0